import { initializeApp } from 'firebase/app'
import { config } from 'src/utils/config'

export const app = initializeApp({
  // https://firebase.google.com/support/guides/security-checklist#api-keys-not-secret
  apiKey: config.firebase.apiKey,
  authDomain: 'mewtant-pixai.firebaseapp.com',
  projectId: 'mewtant-pixai',
  storageBucket: 'mewtant-pixai.appspot.com',
  messagingSenderId: '106543755468',
  appId: '1:106543755468:web:fab58eea1e5e9e7a5b1269',
  measurementId: 'G-3B8JKQXMDQ',
})
